import dayjs from 'dayjs';

const generateFirstDayDates = (startYear) => {
  const currentYear = dayjs().year();
  const currentMonth = dayjs().month();
  const dates = [];

  for (let year = startYear; year <= currentYear; year++) {
    for (let month = 0; month < 12; month++) {
      if (year === currentYear && month > currentMonth) break;

      const date = dayjs().year(year).month(month).date(1);
      dates.push(date.format("YYYY-MM"));
    }
  }

  return dates.sort((a, b) =>
    dayjs(b, "YYYY-MM").diff(dayjs(a, "YYYY-MM"))
  );
};


export const PERIODS = generateFirstDayDates(2024);

export const NO_EES = "Falta Firma EES";
export const NO_EES_TEMP = "Falta Firma EES Temporal";
export const NO_SUBTEL = "Falta firma SUBTEL";
export const NO_MINEDUC = "Falta firma MINEDUC";
export const APROVED = "Aprobado";
export const REJECTED = "Rechazado";
export const PENDING = "En Proceso";

export const ROL_ADMIN = 1;
export const ROL_OP_ADMIN = 3;
export const ROL_OP_INS = 4;
export const ROL_REP_EES = 5;
export const ROL_REP_EES_TEMP = 11;
export const ROL_ADMIN_SUBTEL = 6;
export const ROL_VAL_SUBTEL = 7;
export const ROL_CON_MINEDUC = 8;
export const ROL_MINEDUC_ADMIN = 9;

export const ROLE_LABELS = {
  [ROL_ADMIN]: 'Administrador',
  [ROL_OP_ADMIN]: 'Operador Admin',
  [ROL_OP_INS]: 'Operador Instalador',
  [ROL_REP_EES]: 'Representante EES',
  [ROL_REP_EES_TEMP]: 'Representante EES Temporal',
  [ROL_ADMIN_SUBTEL]: 'Administrador SUBTEL',
  [ROL_VAL_SUBTEL]: 'Validador SUBTEL',
  [ROL_CON_MINEDUC]: 'Consolidación MINEDUC',
  [ROL_MINEDUC_ADMIN]: 'Administrador MINEDUC',
};

export const ALL_ROLE_IDS = Object.keys(ROLE_LABELS).map(Number);

export const QUESTIONS = [
  "¿Usted está de acuerdo con la medición de velocidad (speed test) realizada por el técnico instalador?",
  "¿Es satisfactoria para usted la instalación física del equipamiento en general del servicio?",
  "¿Usted recibió indicaciones claras del técnico instalador de qué hacer ante anomalías del servicio?",
  "¿Usted recibió material de apoyo por parte del técnico instalador?",
];

export const MAX_JUSTIFICACION = 3000;

export const REJECT_F_OTRO = "Otro Motivo.";

export const REJECT_F = [
"EES no cuenta con disponibilidad de servicio o sin tráfico de datos de acuerdo a la información del monitoreo en línea, en el momento de la revisión.",
"No adjuntan imágenes de Speed Test, pérdida de paquetes y equipos instalados.",
"No cumple con las velocidades adjudicadas.",
REJECT_F_OTRO,
]

export const DEFAULT_ITEMS_CONTINGENCIAS = [
  {
    id: "1",
    type: "PROGRAMADA",
    subtype: "Falla interna al adjudicatario",
    title: "JUSTIFICACIÓN DE INDISPONIBILIDAD PROGRAMADA",
    description:
    "Tipo de Justificación de Indisponibilidad de común acuerdo entre Operador y Establecimiento <b>para acreditar cortes de servicios programados y recurrentes en un determinado tiempo a nivel de Establecimiento.</b>",
    actionText: "Crear justificación de indisponibilidad",
  },
  {
    id: "2",
    type: "ESPECIFICA",
    subtype: "Falla externa al adjudicatario",
    title: "JUSTIFICACIÓN DE INDISPONIBILIDAD EXTERNA",
    description:
      "Tipo de Justificación de Indisponibilidad para <b>acreditar algún corte o inestabilidad en el servicio por un evento imprevisto y no recurrente externo</b> al Establecimiento.",
    actionText: "Crear justificación de indisponibilidad",
  },
  {
    id: "3",
    type: "ESPECIFICA",
    subtype: "Falla interna al adjudicatario",
    title: "JUSTIFICACIÓN DE INDISPONIBILIDAD INTERNA",
    description:
      "Tipo de Justificación de Indisponibilidad para <b>acreditar algún corte o inestabilidad en el servicio por un evento imprevisto y no recurrente</b> dentro del establecimiento.",
    actionText: "Crear justificación de indisponibilidad",
  },
  {
    id: "4",
    type: "ZONAL",
    subtype: "Falla externa al adjudicatario",
    title: "JUSTIFICACIÓN DE INDISPONIBILIDAD ZONAL",
    description:
      "Tipo de Justificación de Indisponibilidad para <b>acreditar algún corte o inestabilidad en el servicio por un evento particular y/o fortuito</b> que suceda a nivel de <b>Zona</b>.",
    actionText: "Crear justificación de indisponibilidad",
  },
];

export const CRITERIOS_CONTINGENCIAS = [
  {
    codigo: "101",
    tipoId: "3",
    title: "1. Corte de suministro eléctrico.",
    label: "101 - Corte de suministro eléctrico",
  },
  {
    codigo: "102",
    tipoId: "2",
    title: "2. Cortes de fibra óptica y daños a la infraestructura por fuerza mayor.",
    label: "102 - Cortes de fibra óptica y daños a la infraestructura por fuerza mayor",
  },
  {
    codigo: "104",
    tipoId: "2",
    title: "3. Cortes de fibra óptica por acción de terceros: afectaciones a infraestructura de telecomunicaciones.",
    label: "104 - Cortes de fibra óptica por acción de terceros",
  },
  {
    codigo: "106",
    tipoId: "3",
    title: "4. Apagado de equipamiento o corte interior —en ventana de servicio, visita y con firma colegio—.",
    label: "106 - Apagado de equipamiento o corte interior",
  },
  {
    codigo: "107",
    tipoId: "1",
    title: "5. Corte de suministro eléctrico y desconexión manual de equipos —intervención o manipulación de terceros colegios—.",
    label: "107 - Corte de suministro eléctrico y desconexión manual de equipos",
  },
  {
    codigo: "108",
    tipoId: "1",
    title: "6. Cierre de establecimientos educacionales rurales y traslados.",
    label: "108 - Cierre de establecimientos educacionales rurales y traslados",
  },
  {
    codigo: "109",
    tipoId: "4",
    title: "7. Justificación de indisponibilidad zonal.",
    label: "109 - Justificación de indisponibilidad zonal",
  },
];

export const CODIGOS_CRITERIO_CONTINGENCIA = Object.fromEntries(
  CRITERIOS_CONTINGENCIAS.map((criterio) => [criterio.codigo, criterio.label])
);

export const DAYS = ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"];

export const borderStyle = '1px solid #BDBDBD';
export const tbPad = 1.2;
export const sxEstilos = {
  caja: {
    border: borderStyle,
    borderRadius: 1,
    overflow: 'hidden',
    m: 1,
    mt:0,
  },
  thGray: {
    backgroundColor: '#A8A8A880',
    fontWeight: 'bold',
    border: borderStyle,
    textAlign: 'left',
    p: tbPad,
  },
  thLGray: {
    backgroundColor: '#A8A8A833',
    fontWeight: 'bold',
    border: borderStyle,
    textAlign: 'left',
    p: tbPad,
  },


  thRed: {
    color: '#D84315',
    fontWeight: 'bold',
    border: borderStyle,
    textAlign: 'center',
    p: tbPad,
  },

  thRedL: {
    color: '#D84315',
    border: borderStyle,
    textAlign: 'center',
    p: tbPad,
  },
  tdLabel: {
    fontWeight: 'bold',
    border: borderStyle,
    p: tbPad,
  },
  tdLabelExtra: {
    fontWeight: 'bold',
    border: borderStyle,
    p: tbPad,
    pl: 3,
  },
  tdNormal: {
    border: borderStyle,
    fontWeight: '400',
    textAlign: 'center',
    p: tbPad,
  },
  tdNormalBold: {
    border: borderStyle,
    fontWeight: 'bold',
    textAlign: 'center',
    p: tbPad,
  },
  tdTotal: {
    color: '#D84315',
    fontWeight: 'bold',
    border: borderStyle,
    textAlign: 'center',
    p: tbPad,
  },
  rowLightRed: {
    backgroundColor: '#F8D7D7',
  },
  rowGray: {
    backgroundColor: '#A8A8A880',
  },
};


//import {NO_EES_TEMP, NO_SUBTEL, NO_MINEDUC, ROL_ADMIN, ROL_OP_ADMIN, ROL_OP_INS, ROL_REP_EES, ROL_REP_EES_TEMP, ROL_VAL_SUBTEL, ROL_CON_SUBTEL, ROL_MINEDUC_ADMIN} from "../Constants/Constants";